/**
 * Toast alert
 * @param {string} text Message
 * @param {object} [options] Options
 * @param {('success','warning','danger','info')} options.type Type of toast alert
 */
export const toastAlert = (text, options = {}) => {
    options = Object.assign({}, {type: 'success'}, options)

    let container = $(".toasts");
    let dom = $(`<div role="alert" aria-live="assertive" class="toast bg-${options.type} border-0 text-white mt-2"></div>`);
    dom.append($(`<div class="toast-body">${text}</div>`));
    dom.append($(`<button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>`));
    container.append(dom);

    let toast = new bootstrap.Toast(dom[0], {});
    toast.show();

    setTimeout(() => {
        dom.remove();
    }, 10000)
}